import { render } from "./CheckOutPage.vue?vue&type=template&id=1b3c1877"
import script from "./CheckOutPage.vue?vue&type=script&lang=js"
export * from "./CheckOutPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__